<script lang="ts">
  import type { NewsSection } from '$lib/sanity/schemas';
  import SanityGridLayout from '$components/SanityComponents/SanityGridLayout.svelte';
  import type { ContentSourceMap, StudioPathLike } from '@sanity/svelte-loader';

  interface Props {
    document: NewsSection;
    sourceMap: ContentSourceMap;
    path?: StudioPathLike;
  }

  let { document, sourceMap, path = [] }: Props = $props();
</script>

<section>
  {#if document.layout}
    <SanityGridLayout layout={document.layout} {sourceMap} path={[...path, 'layout']} />
  {/if}
</section>

<style lang="scss">
  @import 'src/scss/media';
  @import 'src/scss/variables';

  section {
    padding-bottom: var(--twist-core-spacing-7);
  }
</style>
